export enum BulkListingStep {
    CHOOSE_MATERIAL = 'CHOOSE_MATERIAL',
    IMPORT_LISTINGS = 'IMPORT_LISTINGS',
    EDIT_LISTINGS = 'EDIT_LISTINGS',
    EXPIRY_DATE = 'EXPIRY_DATE',
}
